
import { Component, Vue } from 'vue-property-decorator'
import { DsOpenConsoleSidebar } from 'ds-open-console-sidebar'
import 'ds-open-console-sidebar/libs/ds-open-console-sidebar.css'
import { routes } from '@/router'

interface MenuItem {
  label: string
  name: string
  icon: string
  path?: string
}

interface SidebarMenu {
  title: string
  menus: MenuItem[]
}

@Component({
  components: {
    DsOpenConsoleSidebar
  }
})
export default class Sidebars extends Vue {
  get currentMenus() {
    const currentRoute = this.$route
    const sidebarMenu: SidebarMenu = {
      title: '',
      menus: []
    }
    const menuRoute = routes.find((route) => route?.name === currentRoute.matched[0]?.name)
    if (menuRoute?.children?.length && menuRoute?.meta?.menuLabel) {
      const menus: MenuItem[] = menuRoute.children
        .filter((route) => {
          const { name, menuLabel } = route?.meta ?? {}
          return this.$store.getters.checkPermission(name) && menuLabel
        })
        .map((route) => {
          return {
            label: route.meta?.menuLabel ?? '',
            icon: route.meta?.icon ?? '',
            name: route?.name ?? '',
            path: route.path
          }
        })
      sidebarMenu.title = menuRoute.meta.menuLabel
      sidebarMenu.menus = menus
    }
    return sidebarMenu
  }

  // XXX: 还有没有更好的方法可以实现菜单高亮
  get activeMenu() {
    const { name: routeName, path: routePath } = this.$route
    let activeItem = this.currentMenus.menus.find((menu: MenuItem) => menu.name === routeName)
    if (!activeItem) {
      this.currentMenus.menus.forEach((menu: MenuItem) => {
        if (menu.path && routePath.startsWith(menu.path)) {
          activeItem = menu
        }
      })
    }
    return activeItem
  }

  handleNav({ name }: MenuItem) {
    if (!name || name === this.$route.name) return
    this.$router.push({ name })
  }
}
